import { render, staticRenderFns } from "./InvestmentTransactionNavbar.vue?vue&type=template&id=7b3ff0d0&scoped=true"
import script from "./InvestmentTransactionNavbar.vue?vue&type=script&lang=ts"
export * from "./InvestmentTransactionNavbar.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentTransactionNavbar.vue?vue&type=style&index=0&id=7b3ff0d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3ff0d0",
  null
  
)

export default component.exports